/*
 * @Descripttion: 
 * @version: 
 * @Author: hanzb
 * @Date: 2019-11-21 14:58:03
 * @LastEditors: hanzb
 * @LastEditTime: 2020-04-13 15:53:21
 */
const SgiFormPopUIEO = function () {
    return {
        alwBlk: true,
        // btnN:"上传文件", // 按钮名称
        // c:"desId",
        cluW: 80, // 按钮宽度
        ctlH: 0,
        ctlW: 24,
        ctlN: "弹出",
        desId: "EP_EO_UI_3011",
        // iconPh:"upload", // 按钮图标
        inpPopTe: "--请选择--",
        isDis: false,
        isHdn: false,
        lblW: 6,
        // mulSel:true, // 设置是否允许多选

        // closeI:"SD_RP_IR_0001`UI`UI05", // 关闭按钮图标
        // fileNameI:"SD_RP_IR_0001`UI`UI03", // 文件图标
        // isLbl:false,
        // isRead:false,
        lblAlg: "right",
        // msfTgt:"qtip",


        isGw: false,
        isSrp: true,
        // maxL: 40,//谁打开的？？没事别打开！！
        // minL: 0,
        // n:"描述GUID",
        sNo: 10,
        // t:"uploadFile",
        te: "弹出窗",
        // useTim:0,
        // visible:true,
        // x:"0",
        // y:"0",

        title: "我是标题",
        okText: "确认按钮文字",
        cancelText: "取消按钮文字",
        closable: true,// 是否显示右上角的关闭按钮
        width: 520,// 宽度，string|number	520
        // footer: [
        //         <Button key="back" onClick={this.handleCancel}>返回</Button>,
        //         <Button key="submit" type="primary" onClick={this.handleOk}>
        //           提交
        //         </Button>,
        //       ],// 底部内容，当不需要默认底部按钮时，可以设为 footer={null}
        footer: [],//

        modalContext: [ //自己加的
            // <p>Some contents...</p>,
            // <p>Some contents...</p>,
            // <p>Some contents...</p>
        ],
    }
}

export { SgiFormPopUIEO };
export default SgiFormPopUIEO;



// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiFormPopUIEO.js